// Skąd przyszedł użytkownik (first touch) - zapisywane raz, przy pierwszej wizycie.
// Panel punktdowodzenia zestawia rejestracje po tym polu.
const KEY = 'referral_source';

// Nazwa hosta odsyłacza -> kanał. Kolejność jest istotna: asystenci AI stoją
// PRZED wyszukiwarkami, bo `gemini.google.com` zawiera „google" i bez tego ruch
// z Gemini zapisywałby się jako zwykły wynik organiczny.
const KANALY = [
  ['chatgpt', 'chatgpt'],
  ['chat.openai', 'chatgpt'],
  ['openai', 'chatgpt'],
  ['gemini.google', 'gemini'],
  ['bard.google', 'gemini'],
  ['aistudio.google', 'gemini'],
  // Gemini otwiera odsyłacze przez własne przekierowanie na googleusercontent.
  ['googleusercontent', 'gemini'],
  ['perplexity', 'perplexity'],
  ['claude.ai', 'claude'],
  ['copilot', 'copilot'],
  ['edgeservices.bing', 'copilot'],
  ['grok', 'grok'],
  ['deepseek', 'deepseek'],
  ['chat.mistral', 'mistral'],
  ['facebook', 'facebook'],
  ['messenger', 'facebook'],
  ['instagram', 'instagram'],
  ['tiktok', 'tiktok'],
  ['bing', 'bing'],
  ['duckduckgo', 'duckduckgo'],
  ['google', 'google'],
];

// Nierozpoznany host zapisujemy pod własną nazwą (bez „www."), bo nawet surowa
// domena mówi więcej niż „wejście bezpośrednie".
function rozpoznajKanal(host) {
  const czysty = String(host || '').toLowerCase().replace(/^www\./, '');
  for (const [fragment, kanal] of KANALY) {
    if (czysty.includes(fragment)) return kanal;
  }
  return czysty;
}

export function captureReferral() {
  try {
    if (localStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    let ref = params.get('utm_source');
    if (!ref && params.get('gclid')) ref = 'googleads';
    if (!ref && params.get('fbclid')) ref = 'facebook';
    if (!ref && document.referrer) {
      try {
        const host = new URL(document.referrer).hostname;
        if (host && host !== window.location.hostname) ref = rozpoznajKanal(host);
      } catch { /* zły referrer - ignorujemy */ }
    }
    // Uwaga: 'direct' to nie tylko wpisany adres. Tak samo wygląda wejście
    // z aplikacji i z asystentów AI, którzy ukrywają odsyłacz - tych z domeny
    // nie rozpoznamy w ogóle.
    localStorage.setItem(KEY, ref || 'direct');
  } catch { /* localStorage niedostępny */ }
}

export function getReferral() {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
}
